import React, { useState, useEffect } from 'react';
import styles from './style.module.scss';
import Button from '../../../../../components/new-button';
import { sendOtp as sendOtpApi } from '../../../../../../api';
import useSalesFormStore from '../../../../../stores/sales-form';
import ShieldCheckIcon from '../../../../../assets/svg/icons/common/ShieldCheckIcon';
import CheckCircleIcon from '../../../../../assets/svg/icons/common/CheckCircleIcon';
import PendingIcon from '../../../../../assets/svg/icons/common/PendingIcon';
import CheckCircle from '../../../../../assets/svg/icons/common/CheckCircle';

const SendOtp = ({ data, editSlug }) => {

  const setIsOtpSent = useSalesFormStore((state) => state.setIsOtpSent);
  const [selectedSigner, setSelectedSigner] = useState(0);
  const activeSigner = useSalesFormStore((state) => state.activeSigner);
  const setActiveSigner = useSalesFormStore((state) => state.setActiveSigner);
  const activeOtpMethod = useSalesFormStore((state) => state.activeOtpMethod);
  const setActiveOtpMethod = useSalesFormStore((state) => state.setActiveOtpMethod);
  const setSignerType = useSalesFormStore((state) => state.setSignerType);
  const minimumData = useSalesFormStore((state) => state.minimumData);

  const handleSendOtp = (editSlug) => {
    sendOtpApi(editSlug, {
      signer_id: activeSigner.id,
      method: activeOtpMethod
    }).then((res) => {
      setIsOtpSent(true);
    });
  };

  const handleSignerTypeSelection = (signer, index) => {
    const signers = minimumData?.signers;
    if (signers.length > 1) {
      if (index === 0) {
        setSignerType('First');
      } else {
        setSignerType('Second');
      }
    } else {
      setSignerType(undefined);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <div className={styles.header}>
            <div className={styles.iconCircle}>
              <div className={styles.iconMiddleCircle}>
                <div className={styles.iconInnerCircle}>
                  <div className={styles.shieldIcon}>
                    <ShieldCheckIcon width={24} height={24} />
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.textSection}>
              <h3 className={styles.title}>Complete the application for {data?.dba_name}</h3>
              <p className={styles.description}>
                To protect your business information, we'll send a one-time verification code.
              </p>
            </div>

            {activeSigner === null && (
              <div className={styles.signerSection}>
                <p className={styles.signerTitle}>Select application signer</p>
                <div className={styles.signerList}>
                  {data?.signers?.map((signer, index) => (
                    <div
                      key={index}
                      className={`${styles.signerCard} ${selectedSigner === index ? styles.selected : ''}`}
                      onClick={() => {
                        setSelectedSigner(index);
                        setActiveSigner(signer);
                        handleSignerTypeSelection(signer, index);
                      }}
                    >
                      <div className={styles.signerText}>
                        <div className={styles.signerContent}>
                          <p className={styles.signerName}>{signer.name}</p>
                          <div className={styles.signerContacts}>
                            <span className={styles.signerEmail}>
                              {signer.email.slice(0, 4)}****{signer.email.slice(-9)}
                            </span>
                            <span className={styles.separator}>|</span>
                            <span className={styles.signerPhone}>
                              {signer.phone.slice(0, 3)}***{signer.phone.slice(-4)}
                            </span>
                          </div>
                        </div>
                        <div className={`${styles.badge} ${styles[signer.status]}`}>
                          {signer.status === 'signed' ? (
                            <>
                              <CheckCircle width={14} height={14} />
                              <span>Signed</span>
                            </>
                          ) : (
                            <>
                              <PendingIcon width={14} height={14} />
                              <span>Pending</span>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {activeSigner !== null && (
              <div className={styles.signerSection}>
                <p className={styles.signerTitle}>Select preferred method</p>
                <div className={styles.otpMethods} >
                  <div className={`${styles.otpMethodItem} ${activeOtpMethod === 'sms' ? styles.active : ''}`} onClick={() => setActiveOtpMethod('sms')}>
                    <div className={styles.otpMethodIcon}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M10.875 12C10.875 11.7775 10.941 11.56 11.0646 11.375C11.1882 11.19 11.3639 11.0458 11.5695 10.9606C11.7751 10.8755 12.0013 10.8532 12.2195 10.8966C12.4377 10.94 12.6382 11.0472 12.7955 11.2045C12.9529 11.3618 13.06 11.5623 13.1034 11.7805C13.1468 11.9988 13.1245 12.225 13.0394 12.4305C12.9542 12.6361 12.81 12.8118 12.625 12.9354C12.44 13.059 12.2225 13.125 12 13.125C11.7017 13.125 11.4155 13.0065 11.2045 12.7955C10.9936 12.5845 10.875 12.2984 10.875 12ZM7.87502 13.125C8.09753 13.125 8.31504 13.059 8.50004 12.9354C8.68505 12.8118 8.82924 12.6361 8.91439 12.4305C8.99954 12.225 9.02182 11.9988 8.97841 11.7805C8.935 11.5623 8.82785 11.3618 8.67052 11.2045C8.51319 11.0472 8.31273 10.94 8.0945 10.8966C7.87627 10.8532 7.65007 10.8755 7.44451 10.9606C7.23894 11.0458 7.06324 11.19 6.93962 11.375C6.816 11.56 6.75002 11.7775 6.75002 12C6.75002 12.2984 6.86855 12.5845 7.07953 12.7955C7.29051 13.0065 7.57666 13.125 7.87502 13.125ZM16.125 13.125C16.3475 13.125 16.565 13.059 16.75 12.9354C16.935 12.8118 17.0792 12.6361 17.1644 12.4305C17.2495 12.225 17.2718 11.9988 17.2284 11.7805C17.185 11.5623 17.0779 11.3618 16.9205 11.2045C16.7632 11.0472 16.5627 10.94 16.3445 10.8966C16.1263 10.8532 15.9001 10.8755 15.6945 10.9606C15.4889 11.0458 15.3132 11.19 15.1896 11.375C15.066 11.56 15 11.7775 15 12C15 12.2984 15.1186 12.5845 15.3295 12.7955C15.5405 13.0065 15.8267 13.125 16.125 13.125ZM21.75 6V18C21.75 18.3978 21.592 18.7794 21.3107 19.0607C21.0294 19.342 20.6478 19.5 20.25 19.5H7.78127L4.72503 22.14L4.71659 22.1466C4.44662 22.3755 4.10397 22.5008 3.75003 22.5C3.52968 22.4995 3.31211 22.4509 3.11253 22.3575C2.85365 22.2379 2.63468 22.0462 2.48174 21.8055C2.3288 21.5648 2.24836 21.2852 2.25003 21V6C2.25003 5.60218 2.40806 5.22064 2.68936 4.93934C2.97067 4.65804 3.3522 4.5 3.75003 4.5H20.25C20.6478 4.5 21.0294 4.65804 21.3107 4.93934C21.592 5.22064 21.75 5.60218 21.75 6ZM20.25 6H3.75003V21L7.00971 18.1875C7.14523 18.068 7.31934 18.0014 7.50002 18H20.25V6Z" fill="#3A383F" />
                      </svg>
                    </div>
                    <div className={styles.otpMethodText}>
                      <span>Send via SMS</span>
                      <span className={styles.otpMethodPhone}>
                        {activeSigner.phone.slice(0, 3)}***{activeSigner.phone.slice(-4)}
                      </span>
                    </div>
                  </div>


                  <div className={`${styles.otpMethodItem} ${activeOtpMethod === 'email' ? styles.active : ''}`} onClick={() => setActiveOtpMethod('email')}>
                    <div className={styles.otpMethodIcon}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M21 4.5H3C2.80109 4.5 2.61032 4.57902 2.46967 4.71967C2.32902 4.86032 2.25 5.05109 2.25 5.25V18C2.25 18.3978 2.40804 18.7794 2.68934 19.0607C2.97064 19.342 3.35218 19.5 3.75 19.5H20.25C20.6478 19.5 21.0294 19.342 21.3107 19.0607C21.592 18.7794 21.75 18.3978 21.75 18V5.25C21.75 5.05109 21.671 4.86032 21.5303 4.71967C21.3897 4.57902 21.1989 4.5 21 4.5ZM12 12.4828L4.92844 6H19.0716L12 12.4828ZM9.25406 12L3.75 17.0447V6.95531L9.25406 12ZM10.3641 13.0172L11.4891 14.0531C11.6274 14.1801 11.8084 14.2506 11.9963 14.2506C12.1841 14.2506 12.3651 14.1801 12.5034 14.0531L13.6284 13.0172L19.0659 18H4.92844L10.3641 13.0172ZM14.7459 12L20.25 6.95438V17.0456L14.7459 12Z" fill="#3A383F" />
                      </svg>
                    </div>
                    <div className={styles.otpMethodText}>
                      <span>Send via Email</span>
                      <span className={styles.otpMethodPhone}>
                        {activeSigner.email.slice(0, 4)}****{activeSigner.email.slice(-9)}
                      </span>
                    </div>
                  </div>

                </div>

                <div className={styles.buttonSection}>
                  <Button
                    variant="ghost"
                    type="button"
                    icon={
                      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                        <path d="M21.5006 12.0004C21.5006 12.1993 21.4216 12.3901 21.2809 12.5307C21.1403 12.6714 20.9495 12.7504 20.7506 12.7504H6.0609L11.5312 18.2198C11.6009 18.2895 11.6562 18.3722 11.6939 18.4632C11.7316 18.5543 11.751 18.6519 11.751 18.7504C11.751 18.849 11.7316 18.9465 11.6939 19.0376C11.6562 19.1286 11.6009 19.2114 11.5312 19.281C11.4615 19.3507 11.3788 19.406 11.2878 19.4437C11.1967 19.4814 11.0991 19.5008 11.0006 19.5008C10.902 19.5008 10.8045 19.4814 10.7134 19.4437C10.6224 19.406 10.5396 19.3507 10.47 19.281L3.71996 12.531C3.65023 12.4614 3.59491 12.3787 3.55717 12.2876C3.51943 12.1966 3.5 12.099 3.5 12.0004C3.5 11.9019 3.51943 11.8043 3.55717 11.7132C3.59491 11.6222 3.65023 11.5394 3.71996 11.4698L10.47 4.71979C10.6107 4.57906 10.8016 4.5 11.0006 4.5C11.1996 4.5 11.3905 4.57906 11.5312 4.71979C11.6719 4.86052 11.751 5.05139 11.751 5.25042C11.751 5.44944 11.6719 5.64031 11.5312 5.78104L6.0609 11.2504H20.7506C20.9495 11.2504 21.1403 11.3294 21.2809 11.4701C21.4216 11.6107 21.5006 11.8015 21.5006 12.0004Z" fill="#254FE2" />
                      </svg>
                    }
                    onClick={() => {
                      setActiveSigner(null);
                    }}
                  >
                    Change signer
                  </Button>

                  <Button
                    variant="primary"
                    type="button"
                    onClick={() => {
                      handleSendOtp(editSlug);
                    }}
                    disabled={!activeOtpMethod}
                  >
                    Send verification code
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SendOtp;